import type { PanelMapping } from '../../dockviewLayoutTypes';
import type { OperationsComponentType } from './operations.components';

export type OperationsPanelType = keyof typeof OPERATIONS_PANELS;
export const OPERATIONS_PANELS = {
  orders: { id: 'orders', contentComponent: 'ordersBlotter', title: 'Orders' },
  trades: { id: 'trades', contentComponent: 'tradesBlotter', title: 'Trades' },
  transfers: { id: 'transfers', contentComponent: 'transfersBlotter', title: 'Transfers' },
} satisfies PanelMapping<string, OperationsComponentType>;
